import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getCurrentLocale, getSupportedLocales } from '../utils/i18nUtils';

export const useLocaleUtils = () => {
  const { i18n } = useTranslation();

  return useMemo(
    () => ({
      supportedLocales: getSupportedLocales(i18n),
      currentLocale: getCurrentLocale(i18n),
    }),
    [i18n],
  );
};
